/* TODO:: tennivalók
- user avatart menteni kellene. jelenleg ha rákattintaszt az Edit iconra, akkor megjelenik a képválasztó
- a jelszavakat még menteni kellene. raktam egy form tag-et, azt kitörölheted, ha controlláltan szeretnéd menteni az űrlapot.
- az űrlap mezőkhöz lehet rakni errortext-et, alul a Confirm password mezőnél van egy minta
*/



import { useTranslation } from "react-i18next";
import { useState } from "react";
import { useUser } from "../Context/UserProvider";
import { Link } from "react-router-dom";
import { EditIcon } from "../Components/Icons/EditIcon";
import { Gallery, Item } from "react-photoswipe-gallery";
import ImageInput from "../Components/ImageInput";
import { UserLineIcon } from "../Components/Icons/UserLineIcon";
import TextField from "../Components/InputFields/TextField";
import EmailField from "../Components/InputFields/EmailField";
import { ContactIcon } from "../Components/Icons/ContactIcon";
import PasswordField from "../Components/InputFields/PasswordField";
import { PasswordIcon } from "../Components/Icons/PasswordIcon";
import defaultRiderAvatar from "../Assets/gfx/rider_avatar.webp";
import { HomeIcon } from "../Components/Icons/HomeIcon";


interface UserProfileSettingsProps {}

const UserProfileSettings: React.FunctionComponent<UserProfileSettingsProps> = () => {
  const { t } = useTranslation();

   const { user } = useUser();

  const [showEditProfileImage, setShowEditProfileImage] = useState<boolean>(false);
  const [images, setImages] = useState<File[]>([]);

  const imageUrl = false; 
 
  return (
    <>
    <div className="view-container background-white">
      <div className="view-content">

        <div className="navigationbar navigationbar--dark mb-6">
          <div className="navigationbar__left">
            <Link to="/menu" className="navigationbar__button">
              <HomeIcon />
            </Link>
          </div>
          <div className="navigationbar__center">
            <div className="navigationbar__title">{t("Profile settings")}</div>
          </div>
          <div className="navigationbar__right">
          </div>
        </div>


        <form>
          <div className="heading color-purple mb-6">{t("Profile picture")}</div>

          <div className="mb-6">
            <div className="flex justify-center">
              <div className="user-avatar">
                <div className="relative">
                  <div 
                  className="profile-image__edit-icon profile-image__edit-icon--inverse"
                  onClick={() => {
                    setShowEditProfileImage(true);
                  }}
                  >
                    <EditIcon />
                  </div>
                  {imageUrl ? 
                    <Gallery>
                      <Item original={imageUrl}>
                        {({ ref, open }) => (
                          <>
                            <img
                              onClick={open}
                              src={imageUrl}
                              alt="Profile"
                              style={{
                                width: "100px",
                                height: "100px",
                                //objectFit: "contain",
                              }}
                            />
                          </>
                        )}
                      </Item>
                    </Gallery>
                    :
                    <img
                      src={defaultRiderAvatar}
                      alt="Profile"
                      style={{
                        width: "100px",
                        height: "100px",
                        //objectFit: "contain",
                      }}
                    />
                  }
                </div>
              
              </div>
            </div>
          </div>

          {showEditProfileImage && (
            <div className="mt-6 mb-6">
              <ImageInput
              images={images}
              setImages={setImages}
              title={t("Take Picture")}
              multiple={false}
              required={true}
            />
            </div>
          )}


          <div className="heading color-purple mb-6">{t("Account details")}</div>


          <div className="mb-4">
            <div className="text-secondary mb-2">{t("Name")}</div>
            <TextField 
              name="name" 
              icon={<UserLineIcon/>} 
              defaultValue={user?.name ?? ''} 
              disabled={true} 
            />
          </div>
          
          <div className="mb-4">
            <div className="text-secondary mb-2">{t("E-mail address")}</div>
            <EmailField
              name="email" 
              icon={<ContactIcon/>} 
              defaultValue={user?.email ?? ''} 
              disabled={true} 
            />
          </div>

          <div className="separator-line mb-2"></div>

          <div className="mb-4">
            <div className="text-secondary mb-2">{t("Current password")}</div>
            <PasswordField
              name="password" 
              icon={<PasswordIcon/>} 
              defaultValue="" 
              placeholder="******" 
            />
          </div>


          <div className="mb-4">
            <div className="text-secondary mb-2">{t("New password")}</div>
            <PasswordField
              name="new_password" 
              icon={<PasswordIcon/>} 
              defaultValue="" 
              placeholder={t("New password") as string} 
            />
          </div>

          <div className="mb-4">
            <PasswordField
              name="new_password" 
              icon={<PasswordIcon/>} 
              defaultValue="" 
              placeholder={t("Confirm password") as string} 
            />
            {/* TODO:: ha kell error message, akkor így kellene használni */}
            {/*<div className="input-error-text">error message</div>*/}
          </div>

          <div className="text-small color-secondary">{t("The password must be at least 6 characters long, contain a number, upper and lower case letters.")}</div>

          <div className="mb-10"></div>

          <button type="submit" className="button">{t("Save")}</button>

        </form>
      </div>
    </div>
    </>
  );
};

export default UserProfileSettings;
